import styled from 'styled-components';
import { colors } from '@/styles';

export const BreadCrumbs = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  color: ${colors.secondary.darkGray1};
  gap: 10px;
  font-weight: 500;
  font-size: 16px;
  max-width: 100%;
  /* text-transform: uppercase; */

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span.seperator {
    /* padding: 0 5px; */
  }

  a {
    color: ${colors.semantic.link};
  }
`;

export const BreadCrumbItems = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  min-width: 0;
`;

export const BreadCrumbItem = styled.span`
  flex: 1;
  display: block;
`;

export const FileName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;
